// Destino único de quien no tiene ningún portal. Sin shell: no hay menú que mostrarle.
import { Link } from '@tanstack/react-router';
import { ShieldOff } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import { ProfileGate } from '@/shared/patterns/AppShell/ProfileGate';
import { useLogout } from '@/shared/patterns/AppShell/useLogout';
import { hasMultiplePortals } from './portalAccess';

function NoAccessContent() {
    const { permissions } = useAuth();
    const logout = useLogout();
    const canSwitch = hasMultiplePortals(permissions);
    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
            <span className="flex size-12 items-center justify-center rounded-2xl bg-muted text-muted-foreground">
                <ShieldOff className="size-6" aria-hidden />
            </span>
            <h1 className="max-w-md text-lg font-semibold text-foreground">
                No tienes acceso a ningún portal. Contacta al administrador.
            </h1>
            <div className="flex gap-2">
                {canSwitch && (
                    <Link
                        to="/select-role"
                        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:opacity-90"
                    >
                        Elegir otro portal
                    </Link>
                )}
                <button
                    type="button"
                    onClick={() => void logout()}
                    className="rounded-md border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-accent"
                >
                    Cerrar sesión
                </button>
            </div>
        </div>
    );
}

export function NoAccess() {
    return (
        <ProfileGate>
            <NoAccessContent />
        </ProfileGate>
    );
}
